
import {defineComponent, watch} from 'vue';
import { useTextSelection } from '@vueuse/core'

export default defineComponent({
    name: 'b-form-textarea',
    props: {
        modelValue: String,
        label: String,
        formatter: { type: Function },
        lazyFormatter: { type: Boolean, default: false },
        placeholder: String,
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        rows: {
            type: String,
            default: '3',
        },
        fillContainer: {
          type: Boolean,
          default: false
        },
        maxLength: { type: Number, default: undefined },
    },
    emits: ['update:modelValue', 'input', 'change', 'cursorposition', 'selectedText'],
    setup(props, context) {
        const { rects, text } = useTextSelection()

        watch(text, () => {
          context.emit('selectedText', text);
        })

        function formatValue(value: unknown, evt: any, force = false) {
            const { formatter, lazyFormatter } = props;
            value = String(value);
            if (typeof formatter === 'function' && (!lazyFormatter || force)) {
                // @ts-ignore
                value = formatter(value, evt);
            }
            return value;
        }

        function onInput(evt: any) {
            const { value } = evt.target;
            const formattedValue = formatValue(value, evt);
            if (formattedValue === false || evt.defaultPrevented) {
                evt.preventDefault();
                return;
            }
            context.emit('update:modelValue', value);
            context.emit('input', value);
            context.emit('cursorposition', evt.target.selectionStart);
        }
        function onChange(evt: any) {
            const { value } = evt.target;
            const formattedValue = formatValue(value, evt);
            if (formattedValue === false || evt.defaultPrevented) {
                evt.preventDefault();
                return;
            }
            context.emit('change', formattedValue);
        }

        function onClick(evt: any) {
          context.emit('cursorposition', evt.target.selectionStart);
        }

        return {
            onInput,
            onChange,
            onClick,
        };
    },
});
